<template>
	<div class="finance-table" :style="removePageBreak ? 'page-break-inside: auto' : ''">
		<egranty-section-divider
			icon="attach_money"
			:text="numberOfModules > 1 ? 'Budżet modułu ' + moduleNumber : 'Budżet'"
			:show-print-info="showPrintInfo"
		/>
		<costs-calculated-headers/>

		<v-layout row wrap class="cost-header">
			<v-flex d-flex xs5>
				<v-card color="grey darken-1" dark>
					<v-card-text>
						<h2>A. Koszty administracyjne</h2>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeTotalPrice())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeFromDotation())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeFromOther())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeFromOwnHuman())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeFromOwnFinancial())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout row v-for="cost in normalizedAdministrative" :key="cost.serialNumber">
			<v-layout row wrap>
				<v-flex d-flex xs1 style="border-bottom: none">
					<v-card color="grey lighten-2">
						<v-card-text style="padding-right: 8px">
							<strong>{{cost.serialNumber}}</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs11>
					<v-card color="grey lighten-2 d-flex align-center">
						<v-card-text style="padding-right: 8px">
							<strong>Rodzaj kosztu:</strong>
							{{cost.name}}
						</v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs1 style="border-top: none">
					<v-card color="grey lighten-2">
						<div style="padding-right: 8px">
						</div>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3 d-flex align-center">
						<v-card-text style="padding-right: 8px">
							-
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3 d-flex align-center">
						<v-card-text class="px-1 text-right">{{cost.unitsCount}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3 d-flex align-center">
						<v-card-text class="px-1 text-right">{{formatMoney(cost.pricePerUnit)}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3 d-flex align-center measure-type">
						<v-card-text class="px-1 text-center">{{cost.measureType}}</v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs2>
					<v-card color="grey lighten-2 d-flex align-center">
						<v-card-text class="px-1 text-right">{{formatMoney(cost.totalPrice)}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-3">
						<v-card-text class="px-1 text-right">{{formatMoney(cost.fromDotation)}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3">
						<v-card-text class="px-1 text-right">{{formatMoney(cost.fromOther)}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3">
						<v-card-text class="px-1 text-right">{{formatMoney(cost.fromOwnHuman)}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-3">
						<v-card-text class="px-1 text-right">{{formatMoney(cost.fromOwnFinancial)}}</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-layout>

		<v-layout class="cost-header">
			<v-flex d-flex xs5>
				<v-card color="grey darken-1" dark>
					<v-card-text>
						<h2>P. Koszty programowe</h2>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(actionsTotalPrice())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(actionsFromDotation())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(actionsFromOther())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(actionsFromOwnHuman())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(actionsFromOwnFinancial())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<div row v-for="action in normalizedCosts" :key="'action' + action.serialNumber">
			<v-layout row wrap class="action-summary">
				<v-flex d-flex xs1 style="border-bottom: none">
					<v-card color="grey lighten-1">
						<v-card-text style="padding-right: 8px">
							<strong>{{action.serialNumber}}</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs11>
					<v-card color="grey lighten-1">
						<v-card-text style="padding-right: 8px">
							<strong>Działanie: {{action.name}}</strong>
						</v-card-text>
					</v-card>
				</v-flex>

				<v-flex d-flex xs1 style="border-top: none">
					<v-card color="grey lighten-1">
						<v-card-text style="padding-right: 8px">
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs4>
					<v-card color="grey lighten-1">
						<v-card-text class="px-3 text-right">
							<strong>Suma</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text class="px-1 text-right">{{formatMoney(actionTotalPrice(action))}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs2>
					<v-card color="grey lighten-1">
						<v-card-text class="px-1 text-right">{{formatMoney(actionFromDotation(action))}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text class="px-1 text-right">{{formatMoney(actionFromOther(action))}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text class="px-1 text-right">{{formatMoney(actionFromOwnHuman(action))}}</v-card-text>
					</v-card>
				</v-flex>
				<v-flex d-flex xs1>
					<v-card color="grey lighten-1">
						<v-card-text class="px-1 text-right">{{formatMoney(actionFromOwnFinancial(action))}}
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
			<v-layout row v-for="cost in action.costs" :key="cost.serialNumber">
				<v-layout row wrap>
					<v-flex d-flex xs1 style="border-bottom: none">
						<v-card color="grey lighten-2">
							<v-card-text style="padding-right: 8px">
								<strong>{{action.serialNumber}}.{{cost.serialNumber}}</strong>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs11>
						<v-card color="grey lighten-2">
							<v-card-text style="padding-right: 8px">
								<strong>Rodzaj kosztu:</strong>
								{{cost.name}}
							</v-card-text>
						</v-card>
					</v-flex>

					<v-flex d-flex xs1 style="border-top: none">
						<v-card color="grey lighten-2">
							<v-card-text style="padding-right: 8px">
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text style="padding-right: 8px">
								-
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text class="px-1 text-right">{{cost.unitsCount}}</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text class="px-1 text-right">{{formatMoney(cost.pricePerUnit)}}</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3 measure-type">
							<v-card-text class="px-1 text-center">{{cost.measureType}}</v-card-text>
						</v-card>
					</v-flex>

					<v-flex d-flex xs2>
						<v-card color="grey lighten-2">
							<v-card-text class="px-1 text-right">{{formatMoney(cost.totalPrice)}}</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs2>
						<v-card color="grey lighten-3">
							<v-card-text class="px-1 text-right">{{formatMoney(cost.fromDotation)}}</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text class="px-1 text-right">{{formatMoney(cost.fromOther)}}</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text class="px-1 text-right">{{formatMoney(cost.fromOwnHuman)}}</v-card-text>
						</v-card>
					</v-flex>
					<v-flex d-flex xs1>
						<v-card color="grey lighten-3">
							<v-card-text class="px-1 text-right">{{formatMoney(cost.fromOwnFinancial)}}</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-layout>
		</div>

		<v-layout>
			<v-flex d-flex xs5>
				<v-card color="grey darken-1" dark>
					<v-card-text>
						<h2>Razem</h2>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeTotalPrice() + actionsTotalPrice())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeFromDotation() + actionsFromDotation())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeFromOther() + actionsFromOther())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>{{formatMoney(administrativeFromOwnHuman() + actionsFromOwnHuman())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey darken-1">
					<v-card-text class="px-1 text-right total-price">
						<strong>
							{{formatMoney(administrativeFromOwnFinancial() +
								actionsFromOwnFinancial())}}
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import {Numbers} from "@/utils/Numbers";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
  import CostsCalculatedHeaders from "@/view/logged/offer/components/CostsCalculatedTableComponents/CostsCalculatedHeaders";

	export default {
		name: "ProjectCostsCalculatedTable",

		components: {CostsCalculatedHeaders, EgrantySectionDivider},

		mixins: [Numbers],

		computed: {
			normalizedCosts() {
				let result = [];
				for (let i = 0; i < this.costs.length; i++) {
					let toAdd = {};
					toAdd.serialNumber = this.actions[i].serialNumber;
					toAdd.name = this.actions[i].action;
					toAdd.costs = [];
					for (var cost of this.costs[i]) {
						toAdd.costs.push(this.normalizeCost(cost));
					}
					toAdd.costs.sort((a, b) => a.serialNumber - b.serialNumber);
					result.push(toAdd);
				}
				return result.sort((a, b) => a.serialNumber - b.serialNumber);
			},

			normalizedAdministrative() {
				let result = [];

				for (var administrative of this.administrative) {
					result.push(this.normalizeCost(administrative));
				}

				result.sort((a, b) => a.serialNumber - b.serialNumber);

				return result;
			}
		},

		methods: {
			normalizeCost(cost) {
				let result = {
					serialNumber: cost.serialNumber,
					name: cost.name,
					unitsCount: cost.unitsCount,
					pricePerUnit: cost.pricePerUnit,
					measureType: cost.measureType,
					totalPrice: 0,
					fromDotation: 0,
					fromOther: 0,
					fromOwnHuman: 0,
					fromOwnFinancial: 0
				};

				for (let division of cost.costDivisions) {
					if (division.type === "z dotacji") {
						result.fromDotation += division.totalPrice;
						continue;
					}
					if (division.type === "wkład osobowy") {
						result.fromOwnHuman += division.totalPrice;
						continue;
					}
					if (division.type === "wkład rzeczowy") {
						result.fromOwnFinancial += division.totalPrice;
						continue;
					}
					result.fromOther += division.totalPrice;
				}
				result.totalPrice =
					result.fromDotation +
					result.fromOther +
					result.fromOwnFinancial +
					result.fromOwnHuman;
				return result;
			},

			totalFromActions(getter) {
				let result = 0;
				for (let action of this.normalizedCosts) {
					for (let cost of action.costs) {
						result += getter(cost);
					}
				}
				return result;
			},

			totalFromAdministrative(getter) {
				let result = 0;
				for (let cost of this.normalizedAdministrative) {
					result += getter(cost);
				}
				return result;
			},

			totalFromAction(action, getter) {
				let result = 0;
				for (let cost of action.costs) {
					result += getter(cost);
				}
				return result;
			},

			administrativeTotalPrice() {
				return this.totalFromAdministrative(
					x => x.fromDotation + x.fromOther + x.fromOwnHuman + x.fromOwnFinancial
				);
			},

			administrativeFromDotation() {
				return this.totalFromAdministrative(x => x.fromDotation);
			},

			administrativeFromOwnFinancial() {
				return this.totalFromAdministrative(x => x.fromOwnFinancial);
			},

			administrativeFromOwnHuman() {
				return this.totalFromAdministrative(x => x.fromOwnHuman);
			},

			administrativeFromOther() {
				return this.totalFromAdministrative(x => x.fromOther);
			},

			actionsTotalPrice() {
				return this.totalFromActions(
					x => x.fromDotation + x.fromOther + x.fromOwnHuman + x.fromOwnFinancial
				);
			},

			actionsFromDotation() {
				return this.totalFromActions(x => x.fromDotation);
			},

			actionsFromOwnFinancial() {
				return this.totalFromActions(x => x.fromOwnFinancial);
			},

			actionsFromOwnHuman() {
				return this.totalFromActions(x => x.fromOwnHuman);
			},

			actionsFromOther() {
				return this.totalFromActions(x => x.fromOther);
			},

			actionTotalPrice(action) {
				return this.totalFromAction(action, x => x.fromDotation + x.fromOther + x.fromOwnHuman + x.fromOwnFinancial);
			},

			actionFromDotation(action) {
				return this.totalFromAction(action, x => x.fromDotation);
			},

			actionFromOwnFinancial(action) {
				return this.totalFromAction(action, x => x.fromOwnFinancial);
			},

			actionFromOwnHuman(action) {
				return this.totalFromAction(action, x => x.fromOwnHuman);
			},

			actionFromOther(action) {
				return this.totalFromAction(action, x => x.fromOther);
			}
		},

		props: {
			administrative: {},
			costs: {},
			actions: {},
			numberOfModules: {
				default: 0,
			},
			moduleNumber: {
				default: "",
			},
			showPrintInfo: {
				type: Boolean, default: false
			},
			removePageBreak: {
				type: Boolean, default: false
			},
		}
	};
</script>

<style scoped>
.theme--dark .grey.darken-1[data-v-79227a6f] {
  background-color: #1b1b1b !important;
}

.application.mediumFont .finance-table .v-card__text strong[data-v-79227a6f] {
  font-size: 1em !important;
}

.application.mediumFont
  .finance-table
  .v-card__text.text-center[data-v-79227a6f] {
  font-size: 1em;
}

.application.largeFont
  .finance-table
  .v-card__text.text-center[data-v-79227a6f] {
  font-size: 1em;
}

h2 {
  font-size: 14px;
}
.finance-table .v-card__text.text-right {
  text-align: right;
}
.finance-table .v-card__text.text-center,
.finance-table .v-card__text.total-price strong {
  font-size: 11px;
}
.finance-table .v-card__text strong {
  font-size: 12px;
}
.finance-table strong {
  font-size: 12px;
}
.finance-table .v-card__text {
  padding-top: 7px;
  padding-bottom: 7px;
}

.finance-table .v-card__text {
	font-size: 11px;
}
</style>
